export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 mb-8">
            有任何建议、反馈或合作意向，欢迎通过以下方式联系我们
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center hover:border-primary-200 transition-colors cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-600">feedback@bananacomics.cn</p>
            </div>

            <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center hover:border-primary-200 transition-colors cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600">biz@bananacomics.cn</p>
            </div>

            <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 text-center hover:border-primary-200 transition-colors cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                <i className="ri-file-add-line text-xl"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-600">submit@bananacomics.cn</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}